import clsx from 'clsx'
import React from 'react'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import FieldCopy from '../FieldCopy'

import useStyles from '../styles'

const TextInput = ({
  field,
  value,
  disabled,
  canEdit,
  handleChange,
  handleBlur,
  task,
  inputOnly,
  row,
  rowKey,
  parent,
  inTable
}) => {
  const [startingValue, setStartingValue] = React.useState('')
  const [hovering, setHovering] = React.useState(false)

  const classes = useStyles({ readOnly: disabled, task, inputOnly, inTable })

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(classes.fieldInputRoot, 'cf-input-root')}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(classes.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <FieldCopy inTable={inTable} visible={hovering} text={value} />

      <input
        placeholder={canEdit ? 'Type...' : 'None'}
        value={value}
        onChange={e => handleChange(e, field, row, rowKey, parent)}
        onFocus={() => setStartingValue(value)}
        onBlur={e => {
          if (e.target.value !== startingValue) {
            handleBlur && handleBlur()
          }
        }}
        disabled={disabled || !canEdit}
        className={classes.input}
        style={{ cursor: disabled ? 'not-allowed' : 'auto' }}
      />
    </div>
  )
}

export default TextInput
